// You can write more code here

/* START OF COMPILED CODE */

import UserComponent from './UserComponent';
import Phaser from 'phaser';
/* START-USER-IMPORTS */
import { app } from '../App';
import { FontSettings, LanguageInfo, LocaleHandler } from '../modules/LocaleHandler';
import FitTextToBounds from './FitTextToBounds';
/* END-USER-IMPORTS */

export default class LocaliseText extends UserComponent {
  constructor(gameObject: Phaser.GameObjects.Text | Phaser.GameObjects.BitmapText) {
    super(gameObject);

    this.gameObject = gameObject;
    (gameObject as any)['__LocaliseText'] = this;

    /* START-USER-CTR-CODE */
    this.defaultFont = '';
    this.defaultSettings = {};
    /* END-USER-CTR-CODE */
  }

  static getComponent(gameObject: Phaser.GameObjects.Text | Phaser.GameObjects.BitmapText): LocaliseText {
    return (gameObject as any)['__LocaliseText'];
  }

  private gameObject: Phaser.GameObjects.Text | Phaser.GameObjects.BitmapText;
  public isDynamic: boolean = false;
  public copyId: string = '';
  public useRTLFix: boolean = true;

  /* START-USER-CODE */

  protected defaultFont: string;
  protected defaultSettings: FontSettings;

  protected awake(): void {
    if (this.gameObject instanceof Phaser.GameObjects.Text) {
      this.defaultFont = this.gameObject.style.fontFamily;
      this.defaultSettings.padding = this.gameObject.padding;
    } else if (this.gameObject instanceof Phaser.GameObjects.BitmapText) {
      this.defaultFont = this.gameObject.font;
    }

    this.scene.events.on(LocaleHandler.events.LanguageChanged, this.refreshText, this);
    this.refreshText(app.localeHandler.SelectedLanguage, app.localeHandler.getLanguageInfo());
  }

  protected refreshText(newLanguage: string, languageInfo: LanguageInfo) {
    if (this.gameObject == null) return;

    let isRTL = languageInfo.rtl?.includes(newLanguage);

    if (this.gameObject instanceof Phaser.GameObjects.Text) {
      let newFont = app.localeHandler.getFont(this.defaultFont);
      if (newFont !== '') this.gameObject.setFontFamily(newFont);
    }

    // Reapply default settings.
    if (this.gameObject instanceof Phaser.GameObjects.Text) {
      this.applyFontSettings(this.gameObject, this.defaultSettings);
      let newSettings = app.localeHandler.getFontSettings(this.gameObject.style.fontFamily);
      if (newSettings) this.applyFontSettings(this.gameObject, newSettings);
    }

    // If the text is RTL then we need to tell Phaser and revert some of the RTL defaults.
    if (!this.useRTLFix && this.gameObject instanceof Phaser.GameObjects.Text) {
      if (isRTL) {
        this.gameObject.setStyle({ rtl: true });
        let originX = this.gameObject.originX;
        this.gameObject.initRTL();
        this.gameObject.originX = originX;
      } else {
        this.gameObject.setStyle({ rtl: false });
      }
    }

    // If the text isn't dynamic then we can update the copy and resize it.
    if (!this.isDynamic) {
      this.gameObject.text = app.localeHandler.getLocalisedTextById(this.copyId, { useRTLFix: isRTL && this.useRTLFix});

      // Resize text if needed.
      let fittedText = FitTextToBounds.getComponent(this.gameObject);
      if (fittedText) fittedText.sizeText();
    }
  }

  protected applyFontSettings(text: Phaser.GameObjects.Text, fontSettings: FontSettings) {
    if (fontSettings.padding) text.setPadding(fontSettings.padding);
  }

  protected destroy(): void {
    this.scene.events.off(LocaleHandler.events.LanguageChanged, this.refreshText, this);
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
